<sb-dialog-header>
  <h3 sb-dialog-title>{{ 'Clock map' | translate }}</h3>
</sb-dialog-header>
<sb-dialog-content>
  <sb-maps
    class="h-96 overflow-hidden rounded-lg border border-solid border-default"
    [latitude]="markerOptions[0]?.lat"
    [longitude]="markerOptions[0]?.lng"
    [markers]="markerOptions"
    [showMarkerInfo]="true"
    [fitMarkerBounds]="true"
    [defaultHeight]="false"
    [zoom]="markerOptions[0]?.lat ? 12 : 8"
  />
  <sb-dialog-sidebar>
    @if (timesheet?.clock) {
      <sb-dialog-block [header]="'Clock information' | translate">
        <timesheet-clock-info [timesheet]="timesheet" />
      </sb-dialog-block>
    }
  </sb-dialog-sidebar>
</sb-dialog-content>
